import { render, staticRenderFns } from "./WeightFancyCounter.vue?vue&type=template&id=4ff7177c&scoped=true"
import script from "./WeightFancyCounter.vue?vue&type=script&setup=true&lang=js"
export * from "./WeightFancyCounter.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WeightFancyCounter.vue?vue&type=style&index=0&id=4ff7177c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff7177c",
  null
  
)

export default component.exports